import React from 'react';

import { joinClass } from '../helpers/component';

const KeyValue = (props) => {
  const {
    label,
    value,
    className,
    isTranslationExempt,
  } = props;
  return (
    <div className={joinClass('key-value', className)}>
      {label && (
        <div className="key-value__key">
          <h4 className="body2">{ label }</h4>
        </div>
      )}
      <div className="key-value__value" data-notranslate={isTranslationExempt}>
        {Array.isArray(value) ? value.map(item => <span key={item} className="key-value__value-item">{item}</span>) : value}
      </div>
    </div>
  );
};

export default KeyValue;
